// import router from '@/app/app-router';
import { router } from '@/app/app-router';
import { store } from '@/app/app-store';
import { refsService as refs } from '@/app/shared/refs.service';
import { env } from '@/environments';
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

const axiosConfig: AxiosRequestConfig = {};
const axiosInstance = axios.create(axiosConfig);

const authInterceptor = (config: AxiosRequestConfig) => {
  refs.modules.loading.SET_REQUEST(true);
  const token = store.getters[`${env.oidcModule}/oidcAccessToken`];
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
};

axiosInstance.interceptors.request.use(authInterceptor);

axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => {
    refs.modules.loading.SET_REQUEST(false);
    return response;
  },
  (error: AxiosError) => {
    refs.modules.loading.SET_REQUEST(false);
    refs.util.showErrors(error);
    if (error && error.response && error.response.status === 401)
      router.push({ name: 'logout' });
    return Promise.reject(error);
  }
);

export { axiosInstance };
